<script lang="ts">
	import type { Price } from '$lib/components/types';
	import type { ClassValue } from 'svelte/elements';
	import { formatToPartsPrice } from '$lib/utils/formatPrice';
	import { languageTag } from '$paraglide/runtime';

	interface Props {
		price: Price;
		currencyClass?: ClassValue;
		amountClass?: ClassValue;
		digits?: number;
	}

	const {
		price,
		currencyClass,
		amountClass,
		digits,
	}: Props = $props();

	const parts = $derived(formatToPartsPrice({
		amount: price.amount,
		currency: price.currency,
		language: languageTag(),
		digits,
	}));

	const currencyPosition = $derived(parts[0].type === 'currency' ? 'left' : 'right');
	const currencyPart = $derived(parts.find(part => part.type === 'currency'));
	const priceExtracted = $derived(parts
		.filter(part => part.type !== 'currency')
		.map(part => part.value)
		.join(''));
</script>

{#if currencyPosition === 'left'}
	{@render currencyBlock()}
	{@render priceBlock()}
{:else}
	{@render priceBlock()}
	{@render currencyBlock()}
{/if}

{#snippet priceBlock()}
	<span data-testid="route-card-costs" class={amountClass}>{priceExtracted}</span>
{/snippet}
{#snippet currencyBlock()}
	<span data-testid="route-card-costs-currency" class={currencyClass}>{currencyPart?.value}</span>
{/snippet}
